export enum OfflinePaymentFieldName {
  PAYMENT_REFERENCE_ID = "token"
}
